<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.branch.branch') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.branch.branch'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'branch-create' })"
            >
              {{ $t('administration.branch.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('administration.branch.search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.branch_code }}</td>
          <td>{{ record.prefix }}</td>
          <td class="kh-font">{{ record.branch_name_kh }}</td>
          <td>{{ record.branch_name_en }}</td>
          <td>{{ record.phone }}</td>
          <td>{{ record.email }}</td>
          <td>{{ record.facebook_page }}</td>
          <td class="text-center">
            <span v-if="record.is_head"
              ><i class="far fa-check-square text-primary"></i
            ></span>
            <span v-else><i class="far fa-window-close text-danger"></i></span>
          </td>
          <td class="text-center">
            <a
              href="#"
              class="mr-2"
              @click.prevent="edit(record)"
              v-tooltip="$t('administration.branch.edit')"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              class="text-danger"
              @click.prevent="destroyBranch(record)"
              :disabled="record._deleting"
              v-tooltip="$t('administration.branch.delete')"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'branch',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('branch', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.branch.search
      },
      set(newValue) {
        this.$store.commit('branch/SET_SEARCH', newValue)
        this.$store.commit('branch/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('administration.branch.code') },
        { name: this.$t('administration.branch.prefix') },
        { name: this.$t('administration.branch.name_kh') },
        { name: this.$t('administration.branch.name_en') },
        { name: this.$t('administration.branch.phone') },
        { name: this.$t('administration.branch.email') },
        { name: this.$t('administration.branch.facebook_page') },
        {
          name: this.$t('administration.branch.head_office'),
          style: 'text-align:center; width: 8%;'
        },
        {
          name: this.$t('administration.company.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('branch/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('branch/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'branch-edit',
        params: { id: record.branch_id }
      })
    },
    async destroyBranch(record) {
      if (
        await this.$confirmModal.danger(
          this.$t('administration.branch.are_you_sure_to_delete')
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('branch/destroy', record.branch_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'branch-create') {
      this.$store.commit('branch/RESET_STATE')
    }
    next()
  }
}
</script>
